import { makeStyles, mergeClasses } from "@fluentui/react-components";

const useStyles = makeStyles({
  container: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dot: {
    display: "inline-block",
    borderRadius: "50%",
    backgroundColor: "var(--aco-accent)",
    animationName: {
      "0%, 80%, 100%": { opacity: 0.25, transform: "scale(0.7)" },
      "40%":           { opacity: 1,    transform: "scale(1)" },
    },
    animationDuration: "1.2s",
    animationIterationCount: "infinite",
    animationTimingFunction: "ease-in-out",
  },
  sizeSmall:  { width: "5px",  height: "5px"  },
  sizeMedium: { width: "8px",  height: "8px"  },
  sizeLarge:  { width: "14px", height: "14px" },
  gapSmall:  { gap: "4px" },
  gapMedium: { gap: "6px" },
  gapLarge:  { gap: "10px" },
  delay1: { animationDelay: "-0.32s" },
  delay2: { animationDelay: "-0.16s" },
  delay3: { animationDelay: "0s" },
});

export default function LoadingDots({ size = "medium" }) {
  const styles = useStyles();
  const sizeClass = size === "small" ? styles.sizeSmall : size === "large" ? styles.sizeLarge : styles.sizeMedium;
  const gapClass  = size === "small" ? styles.gapSmall  : size === "large" ? styles.gapLarge  : styles.gapMedium;
  return (
    <span className={mergeClasses(styles.container, gapClass)} role="status" aria-live="polite" aria-label="Loading">
      <span className={mergeClasses(styles.dot, sizeClass, styles.delay1)} />
      <span className={mergeClasses(styles.dot, sizeClass, styles.delay2)} />
      <span className={mergeClasses(styles.dot, sizeClass, styles.delay3)} />
    </span>
  );
}
